<template>
  <div v-if="isTest" class="status-cells">
    <Popper class="status-popper" hover arrow>
      <template #content>
        <div>{{ status }}</div>
        <div v-if="status === 'Тест не пройден' || status === 'В процессе прохождения' || (!passing.currentPassing && passing.differentTypeTest && (['new', 'in_progress', 'instruction'].includes(passing.differentTypeTest.status)))">
          <span>Дата выдачи: </span>{{ last_passing_date }}
        </div>
      </template>
      <div>
        <div>
          <div class="status-icon" v-if="status === 'Тест не выдан'">
            <img src="@/assets/images/icons/clock1.svg" alt="Статус:Тест не выдан"/>
          </div>
          <div class="status-icon" v-else-if="status === 'Тест не пройден'">
            <img src="@/assets/images/icons/clock2.svg" alt="Статус:Тест не пройден"/>
          </div>
          <div class="status-icon"
               v-else-if="status === 'В процессе прохождения'">
            <img src="@/assets/images/icons/clock3.svg" alt="Статус:В процессе прохождения"/>
          </div>
          <div class="status-icon" v-else-if="status === 'Тест завершен'">
            <img src="@/assets/images/icons/clock4.svg" alt="Статус:Тест завершен"/>
          </div>
          <div class="status-icon" v-else-if="status === 'Выдано тестирование с полным отчетом'">
            <img src="@/assets/images/icons/clock5.svg" :alt="'Статус:' + status"/>
          </div>
          <div class="status-icon" v-else-if="status === 'Выдано тестирование с стандартным отчетом'">
            <img src="@/assets/images/icons/clock5.svg" :alt="'Статус:' + status"/>
          </div>
          <div class="status-icon" v-else-if="status === 'Выдано тестирование ТЭИ: Управленческий потенциал'">
            <img src="@/assets/images/icons/clock5.svg" :alt="'Статус:' + status"/>
          </div>
        </div>
      </div>
    </Popper>
  </div>
  <div v-else>
    <span>{{ status }}</span>
    <div v-if="status === 'В процессе прохождения' && expiration_date">
      Доступен до: {{expiration_date}}
    </div>
  </div>
</template>

<script>

export default {
  name: "status-renderer",
  components: {},
  props: {
    passing: {
      type: Object,
      default: null
    },
    status: String,
    finished_tests: Array,
    isTest: {
      type: Boolean,
      default: false,
    },
    expiration_date: {
      type: String,
      default: null,
    },
    last_passing_date: {
      type: String,
      default: null
    },
    test_type: {
      type: String,
      default: null,
    }
  }
};
</script>

<style lang="scss" scoped>
.status-icon {
  width: 22px;
  height: 22px;
  margin: auto;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.status-popper {
  display: block;
  font-size: 14px;
  cursor: help;
}

.status-cells {
  margin: auto;
  display: flex;
  column-gap: 10px;
}

@media (max-width: 768px) {
  .status-cells {
    flex-flow: row-reverse;
  }
}
</style>
